import type { UserInfo } from '@memberjunction/core';
import { OEP_ROLE_NAMES } from '../contracts/roles.js';

/**
 * Staff (OEP Staff role) or an MJ Owner principal — the system user the engine runs gates as is
 * `Type='Owner'` (probed on stage 2026-09-29: __mj.[User] ECAFCCEC-6A37-EF11-86D4-000D3A4E707E).
 */
export function IsStaffOrSystem(user: UserInfo | null | undefined): boolean {
    if (!user) return false;
    // __mj.[User].Type is nchar(15): UserCache delivers 'Owner' space-padded, so compare trimmed.
    if (typeof user.Type === 'string' && user.Type.trim().toLowerCase() === 'owner') return true;
    return IsOEPStaff(user);
}

/**
 * Holds the OEP Staff role — role names trimmed and case-insensitive, from the server-side UserInfo. Unlike
 * IsStaffOrSystem there is no Owner bypass: the staff actions and engine methods are for people, and the
 * Action Authorization guard (T13) refuses the system user too.
 */
export function IsOEPStaff(user: Pick<UserInfo, 'UserRoles'> | null | undefined): boolean {
    const want = OEP_ROLE_NAMES.staff.trim().toLowerCase();
    return (user?.UserRoles ?? []).some((r) => typeof r?.Role === 'string' && r.Role.trim().toLowerCase() === want);
}
